// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.6f45074c',
  revision: '6f45074c',
  branch: 'develop',
  date: 'Fri, 27 Mar 2026 13:35:58 GMT'
};